import { GridColDef } from "@mui/x-data-grid-premium";
import { IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { Link } from "react-router-dom";
import SafeBirthControlRows from "../model";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import SafeBirthControl from "../create";
import BaseMedCardList from "src/components/shared-components/medcard/BaseMedCardList";
//MPOGLU;452303;21032025
const columns: GridColDef[] = [
  {
    field: "update",
    headerName: "Güncelle",
    width: 150,
    renderCell(params) {
      return (
        <Link to={`edit/${params.row.id}`}>
          <EditIcon color="info" />
        </Link>
      );
    },
  },
  { field: "date", headerName: "Tarih", flex: 1 },
  { field: "field1", headerName: "Alan 1", flex: 1 },
  { field: "field2", headerName: "Alan 2", flex: 1 },
  { field: "field3", headerName: "Alan 3", flex: 1 },
  { field: "field4", headerName: "Alan 4", flex: 1 },
  { field: "field5", headerName: "Alan 5", flex: 1 },
  {
    field: "delete",
    headerName: "Sil",
    flex: 1,
    renderCell: (params) => (
      <IconButton onClick={() => console.log(params.row.id)}>
        <DeleteIcon color="error" />
      </IconButton>
    ),
  },
];



function SafeBirthControlList() {
  return (
    <>
      <BaseMedCardList
        title="Güvenli Doğum Kontrol Formu"
        columns={columns}
        rows={SafeBirthControlRows}
        CreateComponent={SafeBirthControl}
        pageSize={10}
      />

      <ByzMuiTypography
        sx={{
          fontSize: 13,
          fontWeight: 400,
          whiteSpace: "nowrap",
          wordWrap: "break-word",
          margin: 0,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      ></ByzMuiTypography>
    </>
  );
}

export default SafeBirthControlList;
